import React, { useState } from 'react';
import { View, StyleSheet, LayoutChangeEvent } from 'react-native';
import { Text } from 'exoflex';

import { Card, Chart, Popover } from '../core-ui';
import { CARD, MAN_DAYS_COLORS } from '../constants/colors';

type HoverContent = {
  message: string;
};

type InputArray = {
  key: string;
  value: number;
  hoverContent?: HoverContent;
};

type FeatureStatus = {
  name: string;
  finished: boolean;
};

type PopoverData = {
  title: string;
  details: string;
  data: Array<FeatureStatus>;
};

type Props = {
  stackBarData: Array<InputArray>;
  popoverData: Array<PopoverData>;
  estimatedBreakdown?: number;
  isSpecialCase?: boolean;
};

export default function ProgressCard(props: Props) {
  let [barWidth, setBarWidth] = useState(0);
  let [pointerWidth, setPointerWidth] = useState(0);
  let [indexPointer, setIndexPointer] = useState(0);

  let onLayout = (e: LayoutChangeEvent) => {
    setBarWidth(e.nativeEvent.layout.width);
  };

  let onBarPressed = (width: number, index: number) => {
    setPointerWidth(width);
    setIndexPointer(index);
  };

  let { stackBarData, popoverData, estimatedBreakdown, isSpecialCase } = props;

  return (
    <Card style={styles.card}>
      <Card.Header style={styles.cardHeader}>
        <View style={styles.rowContainer} onLayout={onLayout}>
          <View style={styles.textContainer}>
            <Text weight="medium" style={styles.textHeader}>
              Estimate Breakdown
            </Text>
            {isSpecialCase ? (
              <Text weight="medium" style={styles.textHeader}>
                Not Available
              </Text>
            ) : (
              <Text weight="medium" style={styles.textHeader}>
                Total Mandays: {estimatedBreakdown} mandays
              </Text>
            )}
          </View>
        </View>
      </Card.Header>
      <Card.Content style={styles.chartContainer}>
        <Chart
          type="Bar"
          data={stackBarData}
          size={barWidth}
          onPress={onBarPressed}
        />
        <View style={styles.popoverContainer}>
          <Popover
            pointerWidth={pointerWidth}
            title={popoverData[indexPointer].title}
            tintColor={MAN_DAYS_COLORS[indexPointer]}
            details={popoverData[indexPointer].details}
            data={popoverData[indexPointer].data}
          />
        </View>
      </Card.Content>
    </Card>
  );
}

const styles = StyleSheet.create({
  flex: {
    flex: 1,
  },
  card: {
    shadowColor: CARD.shadow.NORMAL,
    shadowOpacity: 0.05,
    flex: 1,
  },
  cardHeader: {
    flex: 1,
    width: '100%',
    alignSelf: 'flex-start',
  },
  textContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  textHeader: {
    fontSize: 16,
  },
  rowContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flex: 1,
  },
  chartContainer: {
    flex: 1,
    marginBottom: 12,
  },
  popoverContainer: {
    marginTop: 12,
    flex: 1,
  },
  percentageText: {
    alignSelf: 'flex-end',
  },
});
